const FOOTER = {
  drinkingWarning: 'Beba com moderação',
  about: 'Sobre o Zé Delivery',
  help: 'Ajuda',
  workWithUs: 'Trabalhe conosco',
  termsAndPolicy: 'Termos e Políticas',
  useTerms: 'Termos de uso',
  privacyPolicies: 'Políticas de privacidade',
  partner: 'Parceiro',
  partnerWithUs: 'Quero ser parceiro',
  companyInfo:
    'ZE SOLUCOES TECNOLOGICAS DE COMERCIO DE BEBIDAS LTDA. - CNPJ: 37.657.197/0001-46 | Rua Fradique Coutinho, 1632 - CEP: 05.416-002 Pinheiros - São Paulo/SP',
  acessibility: {
    twitter: 'Acessar - Twitter Zé Delivery',
    facebook: 'Acessar - Facebook Zé Delivery',
    instagram: 'Acessar - Instagram Zé Delivery',
    help: 'Abrir página de ajuda sobre o Zé Delivery.',
    workWithUs: 'Abrir página de vagas no Linkedin do Zé Delivery.',
    useTerms: 'Abrir página de termos de uso do Zé Delivery.',
    privacyPolicies: 'Abrir página de Políticas do Zé Delivery.',
    partnerWithUs: 'Ir para a página do formulário de cadastro',
  },
}

export default FOOTER
